import * as yup from "yup";

export const schema = yup
  .object({
    names: yup
      .string()
      .required("Este campo es requerido")
      .min(2, "Mínimo 2 caracteres"),
    lastNames: yup
      .string()
      .required("Este campo es requerido")
      .min(2, "Mínimo 2 caracteres"),
    email: yup
      .string()
      .email("Correo electrónico inválido")
      .required("El correo electrónico es requerido"),
    phone: yup
      .string()
      .required("El teléfono es requerido")
      .min(10, "Teléfono inválido"),
    direction: yup.string().required("La dirección es requerida"),
    linkedin: yup
      .string()
      .required("El LinkedIn es requerido")
      .url("URL inválida"),
    portfolio: yup
      .string()
      .optional()
      .test(
        "is-url",
        "URL inválida",
        (value) =>
          !value ||
          value.length === 0 ||
          yup
            .string()
            .url()
            .isValidSync(value)
      ),
  })
  .required();
